import {
  Search,
} from "lucide-react";
import {
  type CSSProperties,
} from "react";
import { ModuleHeader } from "../../../../shared/components/ModuleHeader";
import { ApprovalQueue } from "./ApprovalQueue";
import { ReturnedApprovalQueue } from "./ReturnedApprovalQueue";
import { useApprovalsWorkspace, type ApprovalsModuleProps } from "./useApprovalsWorkspace";

export function ApprovalsModule(props: ApprovalsModuleProps) {
  const model = useApprovalsWorkspace(props);
  const {
    user,
    query,
    setQuery,
    statusFilter,
    setStatusFilter,
    setExpandedRequestId,
    resolved,
    rows,
    returnedDecisions,
    assignedApprovalRole,
    stageOptions,
    visibleRows,
    showReturnedQueue,
    closeDecisionComposer,
    stageCount,
  } = model;
  return (<>
    <ModuleHeader
      compact
      eyebrow={
        user.role === "SATIN_ALMA_MUDURU"
          ? "Yönetici Talepleri"
          : "Nihai Karar Talepleri"
      }
      title={
        user.role === "SATIN_ALMA_MUDURU"
          ? "Satın Alma Karar Alanı"
          : "Genel Müdür Karar Alanı"
      }
      description={
        user.role === "SATIN_ALMA_MUDURU"
          ? "Uzmanın hazırladığı ticari dosyaları inceleyin, eksikleri açık görevle geri gönderin veya Genel Müdüre iletin."
          : "Satın Alma Müdürünün önerisini onaylayın veya teklifleri karşılaştırarak bağlayıcı nihai seçimi belirleyin."
      }
      action={
        <div className="approval-queue-count">
          <strong>
            {
              rows.filter(
                (item) =>
                  item.pendingApprovalRole === assignedApprovalRole &&
                  !resolved[item.id],
              ).length
            }
          </strong>
          <span>bekleyen</span>
        </div>
      }
    />
    <section
      className="workflow-status-filter manager-decision-filter"
      style={
        {
          "--workflow-filter-columns": stageOptions.length,
        } as CSSProperties
      }
      aria-label="Karar dosyası durumları"
    >
      {stageOptions.map((option) => (
        <button
          key={option.id}
          type="button"
          className={statusFilter === option.id ? "is-active" : ""}
          aria-pressed={statusFilter === option.id}
          onClick={() => {
            setStatusFilter(option.id);
            setExpandedRequestId(null);
            closeDecisionComposer();
          }}
        >
          <span>{option.label}</span>
          <strong>{stageCount(option)}</strong>
        </button>
      ))}
    </section>
    <section
      className="manager-workspace-toolbar procurement-queue-toolbar"
      aria-label="Dosya arama"
    >
      <label>
        <Search size={17} />
        <input
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder="Talep, ürün, talep eden veya departman ara"
          aria-label="Karar dosyalarında ara"
        />
      </label>
      <span>
        {visibleRows.length +
          (showReturnedQueue ? returnedDecisions.length : 0)}{" "}
        dosya
      </span>
    </section>
    <ReturnedApprovalQueue model={model} />
    <ApprovalQueue model={model} />
  </>);
}
